'use strict';

// Constructor
var DatePicker = function () {
    $(".spf-date-picker").flatpickr();
};

module.exports = DatePicker;
